import React from "react";
import { cn } from "@/lib/utils";
import { useProduct, ProductId } from "@/hooks/useProduct";
import { useAuthState } from "@/hooks/useAuthState";
import { GuestNavbar } from "@/components/navigation/GuestNavbar";
import { AuthenticatedHeader } from "@/components/navigation/AuthenticatedHeader";
import { BottomTabBar } from "@/components/navigation/BottomTabBar";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showNavbar?: boolean;
  fullWidth?: boolean;
}

export function PageLayout({
  children,
  className,
  showNavbar = true,
  fullWidth = false
}: PageLayoutProps) {
  const { productId } = useProduct();
  const { user, isAdmin, loading } = useAuthState();
  
  // Apply product-specific theme class
  const themeClass = productId === ProductId.RELIEF ? 'theme-relief' : 'theme-mindcotine';
  
  return (
    <div className={cn("min-h-screen bg-background overflow-x-hidden max-w-full", themeClass)}>
      {showNavbar && loading && (
        <div className="fixed top-0 left-0 right-0 z-50 h-16 bg-background/95 backdrop-blur-md shadow-[0_4px_12px_-2px_rgba(0,0,0,0.15),0_2px_6px_-2px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_12px_-2px_rgba(0,0,0,0.4),0_2px_6px_-2px_rgba(0,0,0,0.3)]" />
      )}
      {showNavbar && !loading && (
        user ? <AuthenticatedHeader isAdmin={isAdmin} /> : <GuestNavbar />
      )}
      <main
        className={cn(
          "pt-24 min-w-0 overflow-x-hidden",
          !fullWidth && "container mx-auto px-4",
          // Bottom padding: extra space for mobile BottomTabBar when authenticated
          showNavbar && user ? "pb-20 lg:pb-6" : "pb-6",
          className
        )}
      >
        {children}
      </main>
      
      {/* Bottom Tab Bar for authenticated mobile users */}
      {showNavbar && !loading && user && <BottomTabBar />}
    </div>
  );
}
